import { TableCell, TableRow } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import paths from '../../lib/consts/paths';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { IOrder } from '../../lib/interfaces/Order';
import { contentMandatoryFields } from '../Form/form.utils';
import { ProductType } from '@/lib/interfaces/Product';

type UserProfileOrdersRowType = {
	order: IOrder;
};

const UserProfileOrdersRow: FC<UserProfileOrdersRowType> = ({ order }) => {
	const { i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	const contentFields: IEntityContentField[] =
		order.product?.content[currentLanguage];

	return (
		<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
			<TableCell align="left">
				<Moment format="DD.MM.YYYY">{order?.orderDate}</Moment>
			</TableCell>
			<TableCell align="left">
				{contentFields.map((field) => {
					if (field.name === `${contentMandatoryFields.NAME}_${currentLanguage}`) {
						const link =
							order.productType === ProductType.SUBSCRIPTION_PLAN
								? `${paths.plans}`
								: `${paths.products}/${order?.product?.slug}`;
						return (
							<Link key={field.name} to={link}>
								{field.content}
							</Link>
						);
					}
				})}
			</TableCell>
			<TableCell align="left">{order?.unitPrice}</TableCell>
			<TableCell align="left">{order?.orderNumber}</TableCell>
			<TableCell align="left">{order?.status}</TableCell>
		</TableRow>
	);
};

export default UserProfileOrdersRow;
